async function validateOrRefreshToken(){
    // console.log("in validateOrRefreshToken");
    try{
        // console.log("username ",username)
        let currentAcc = myMSALObj.getAccountByUsername(username);
        //let currentAcc =null;
        // console.log("currentAcc ",currentAcc);
        // console.log("loginRequest ",loginRequest);
        const response = await getTokenPopup(loginRequest, currentAcc);
        if(response){
            // console.log("response ",response);
            // console.log("1111 response.accessToken ",response.accessToken);
            localStorage.setItem('parentToken', response.accessToken);
            localStorage.setItem('childToken', response.accessToken);
        }
        return response;
    }
    catch(err){
        // console.log("graph.js validateOrRefreshToken throwing error ",err)
        throw err;
    }
}